import http from "./core";

const basePath = "api/kiosk/Documents";

export const DocumentsService = {
  getPending() {
    return http.get(`${basePath}/GetPending`);
  }
};

export default DocumentsService;
